import {ReviewableId} from "platformed-client/types";
import {platformedClient} from ".";

export async function get(reviewableId: ReviewableId) {
  return await platformedClient.internalRequest("get", "/region/{region}/api/reviewables/{reviewable_id}", {
    path: {reviewable_id: reviewableId},
  });
}
